import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import CompSearchBox from "./components/compSearchBox.vue";
import compRoleLogin from "./components/compRoleLogin.vue";
import CompRoleInfo from "./components/compRoleInfo.vue";
import CompPay from "./components/compPay.vue";
import CompCoin from "./components/compCoin.vue";
import CompStage from "./components/compStage.vue";
import CompMainTask from "./components/compMainTask.vue";
import goodsOptions from "../../components/serverList/goodsOptions.vue";
import timeDateOptions from "../../components/timeList/timeDateOptions.vue";
import CoinSelect from "../../components/selectComponents/coinSelect.vue";

// import CoinTypeOptions from "../../components/serverList/coinTypeOptions.vue";
import TaskOptions from "../../components/serverList/taskOptions.vue";
import { getGameGoodsMap, getReasonMap, getGameCoinMap, getGameServerMap } from "@/utils/dictionary";
export default {
  components: {
    compRoleLogin: compRoleLogin,
    CompRoleInfo: CompRoleInfo,
    CompSearchBox: CompSearchBox,
    CompPay: CompPay,
    CompCoin: CompCoin,
    CompStage: CompStage,
    goodsOptions: goodsOptions,
    timeDateOptions: timeDateOptions,
    CoinSelect: CoinSelect,
    CompMainTask: CompMainTask,
    TaskOptions: TaskOptions
  },
  name: "userRoleInfo",
  data: function data() {
    return {
      serverList: {},
      reasonList: {},
      goodsList: {},
      goodsArray: [],
      coinList: {},
      coinTypeLists: [],
      //tab栏(别换)
      activeName: "roleMsg",
      orderStatus: [{
        label: "已发货",
        value: 1
      }, {
        label: "所有订单",
        value: 2
      }],
      //角色登录日志选择时间
      loginTimedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      //充值日志的选择时间
      payInfoData: {
        payTimedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
        status: 2
      },
      //货币日志的选择时间
      coinInfoData: {
        coinTimedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
        coin_type: "1"
      },
      //道具日志的选择时间
      stageInfoData: {
        goods_id: "",
        stageTimedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")]
      },
      //任务日志的选择时间
      taskInfoData: {
        task_id: "",
        taskTimedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")]
      },
      changeTypeOption: [{
        ID: 0,
        val: "全部"
      }, {
        ID: 1,
        val: "获得"
      }, {
        ID: -1,
        val: "消耗"
      }]
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var index, i;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameGoodsMap();
            case 2:
              _this.goodsList = _context.sent;
              for (index in _this.goodsList) {
                _this.goodsArray.push({
                  goodsId: index,
                  goodsName: _this.goodsList[index]
                });
              }
              _context.next = 6;
              return getGameServerMap();
            case 6:
              _this.serverList = _context.sent;
              _context.next = 9;
              return getReasonMap();
            case 9:
              _this.reasonList = _context.sent;
              _context.next = 12;
              return getReasonMap();
            case 12:
              _this.reasonList = _context.sent;
              _context.next = 15;
              return getGameCoinMap();
            case 15:
              _this.coinList = _context.sent;
              for (i in _this.coinList) {
                _this.coinTypeLists.push({
                  id: i,
                  desc: _this.coinList[i]
                });
              }
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //新增tab栏
    handleClick: function handleClick() {},
    //上面的查询封装的组件，点击查询按钮返回值
    compBtnSearch: function compBtnSearch(e) {
      var _this2 = this;
      if (this.activeName == "roleMsg") {
        this.$nextTick(function () {
          _this2.$refs.roleChild.loadTatleData(e);
        });
      } else if (this.activeName == "loginMsg") {
        this.$nextTick(function () {
          _this2.$refs.loginChild.goMethod("1", e);
        });
      } else if (this.activeName == "payMsg") {
        this.$nextTick(function () {
          _this2.$refs.payChild.goMethod("1", e);
        });
      } else if (this.activeName == "coinMsg") {
        this.$nextTick(function () {
          _this2.$refs.coinChild.goMethod("1", e);
        });
      } else if (this.activeName == "stageMsg") {
        this.$nextTick(function () {
          _this2.$refs.stageChild.goMethod("1", e);
        });
      } else if (this.activeName == "taskMsg") {
        console.log("m", e);
        this.$nextTick(function () {
          _this2.$refs.taskChild.goMethod("1", e);
        });
      }
    }
  }
};